import { DOCS_FORM_NAMES } from "core/consts";
import type { DocsFormDataMapped, Observation } from "core/types";
import type { MigratedForms } from "dsl/ecosystems/RecareDocs/Modal/utils";
import Translations from "translations/types";
import { ACCIDENT_SURGERY_FIELD_CONFIG } from "./AccidentSurgery/pdfCreator";
import { CARDIOLOGY_FIELD_CONFIG } from "./Cardiology/pdfCreator";
import { ENT_FIELD_CONFIG } from "./ENT/pdfCreator";
import { NEUROSURGERY_FIELD_CONFIG } from "./NeuroSurgery/pdfCreator";
import { FieldConfig } from "./pdfCreationUtils";

const FIELD_CONFIGS: Record<
  MigratedForms,
  Array<FieldConfig<MigratedForms>>
> = {
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY]:
    CARDIOLOGY_FIELD_CONFIG as Array<FieldConfig<MigratedForms>>,
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT]: ENT_FIELD_CONFIG as Array<
    FieldConfig<MigratedForms>
  >,
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_NEUROSURGERY]:
    NEUROSURGERY_FIELD_CONFIG as Array<FieldConfig<MigratedForms>>,
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_TRAUMA_SURGERY]:
    ACCIDENT_SURGERY_FIELD_CONFIG as Array<FieldConfig<MigratedForms>>,
};

// LF, CR and other whitespace control chars break HL7 segment parsing.
export const stripControlChars = (text: string): string =>
  text.replace(/[\n\r\t\v\f]+/g, " ").trim();

export function buildDischargeLetterObservation(
  formData: DocsFormDataMapped<MigratedForms>,
  formName: MigratedForms,
  translations: Translations,
  externalId: string,
  formId: number,
): Observation {
  const nowUnix = Math.floor(Date.now() / 1000);
  const fieldConfig = FIELD_CONFIGS[formName];
  const entityId = `${externalId}_${formId}`;

  const nonEmptyFields = fieldConfig.filter((field) => {
    const value = formData[field.key];
    return value != null && String(value).trim() !== "";
  });

  return {
    request: {
      filler_order_id: { entity_id: entityId, namespace_id: "DOC" },
      observation_time: nowUnix,
      set_id: 1,
    },
    result: nonEmptyFields.map((field, index) => ({
      date_time: nowUnix,
      field_label: stripControlChars(field.label(translations)),
      field_name: String(field.key),
      observation_value: String(formData[field.key] ?? "").trim(),
      set_id: index + 1,
    })),
  };
}
